import { DateFields } from '../../../../common/DateFields';
import { NoteFormData } from '../hooks';

interface NoteDateFieldsProps {
  formData: NoteFormData;
  errors: Partial<Record<keyof NoteFormData, string>>;
  onFieldChange: <K extends keyof NoteFormData>(field: K, value: NoteFormData[K]) => void;
  disabled?: boolean;
}

export const NoteDateFields: React.FC<NoteDateFieldsProps> = ({
  formData,
  errors,
  onFieldChange,
  disabled = false,
}) => {
  return (
    <DateFields
      mode="single"
      value={formData.date_of_action}
      onChange={(value) => onFieldChange('date_of_action', value)}
      label="Date of Action"
      error={!!errors.date_of_action}
      helperText={errors.date_of_action || 'When did this activity occur?'}
      disabled={disabled}
    />
  );
};
